document.addEventListener("DOMContentLoaded", function () {
  let productsOnPage, next_url, loadMore_btn, loadMore_spinner, isLoading;

  function initThemeFeatures(context) {
    if (window.theme && typeof window.theme.init === "function") {
      window.theme.init();
    }
    $(context).find(".swatches")
      .off("mouseenter")
      .on("mouseenter", function () {
        const newImg = $(this).data("variant-image");
        if (newImg) {
          $(this).closest(".product-card").find("img").attr("src", newImg);
        }
      });
  }

  function initLoadMore() {
    productsOnPage = $(".loopProducts");
    next_url = productsOnPage.data("next-url");
    loadMore_btn = $(".loadMoreBtn");
    loadMore_spinner = $(".loadMoreSpinner");
    isLoading = false;

    loadMore_btn.off("click").on("click", loadMoreProducts);

    if (!next_url) {
      loadMore_btn.hide();
    } else {
      loadMore_btn.show();
    }

    // console.log("Load More initialized. Next URL:", next_url);
  }

  function loadMoreProducts() {
    if (!next_url || isLoading) return;

    isLoading = true;
    loadMore_btn.hide();
    loadMore_spinner.show();

    $.ajax({
      url: next_url,
      type: "GET",
      dataType: "html",
    })
    .done(function (next_page) {
      const new_products = $(next_page).find(".loopProducts");
      const new_url = new_products.data("next-url");
      const appended = $(new_products.html());

      productsOnPage.append(appended);
      productsOnPage.data("next-url", new_products.data("next-url"));
      next_url = productsOnPage.data("next-url");

      if (next_url) loadMore_btn.show();
      else loadMore_btn.hide();

      initThemeFeatures(appended);
    })
    .fail(function () {
      loadMore_btn.show();
    })
    .always(function () {
      loadMore_spinner.hide();
      isLoading = false;
    });
  }

  // Init once
  initLoadMore();

  // Listen for Shopify section reloads (filter/sort)
  document.addEventListener("shopify:section:load", function (event) {
    if (event.target && event.target.querySelector(".loopProducts")) {
      // console.log("Section reloaded via Shopify API");
      initLoadMore();
    }
  });

  // Extra safety: MutationObserver to detect when .loopProducts is replaced
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === "childList") {
        if ($(mutation.target).find(".loopProducts").length || $(".loopProducts").length) {
          // console.log("Detected .loopProducts change via MutationObserver");
          initLoadMore();
        }
      }
    });
  });

  observer.observe(document.querySelector("main"), { childList: true, subtree: true });
});

